import Select from "react-select";
import { useMemo } from "react";

const PaginatedSelect = ({
    label,
    name,
    value,        // should be primitive id
    onChange,     // we will pass (value, label)
    onSearch,
    options = [],
    error,
    id,
    onLoadMore,
    hasMore,
    loading,
}) => {

    const formattedOptions = useMemo(() => {
        return options.map((opt) => ({
            label: opt.courtName,
            value: opt.id,
        }));
    }, [options]);
    return (
        <div className="custom-select-wrapper ">
            {label && (
                <label htmlFor={id || name} className="form-label">
                    {label} <span className="text-danger">*</span>
                </label>
            )}

            <Select
                inputId={id || name}
                name={name}
                value={value}
                options={formattedOptions}
                placeholder="Select an option"
                isSearchable={true}
                filterOption={null}
                isLoading={loading}
                classNamePrefix="react-select"
                onInputChange={(inputValue, { action }) => {
                    if (action === "input-change") {
                        onSearch && onSearch(inputValue);
                    }
                }}

                onChange={(selected) => {
                    if (selected) {
                        onChange(selected.value, selected.label);
                    } else {
                        onChange("", "");
                    }
                }}
                onMenuScrollToBottom={() => {
                    if (hasMore && !loading && onLoadMore) {
                        onLoadMore();
                    }
                }}
                styles={{
                    control: (base) => ({
                        ...base,
                        minHeight: "48px",
                        height: "48px",     
                        display: "flex",
                        alignItems: "center", 
                        border: "1.5px solid #027a26", 
                        borderRadius: "13px",
                        boxShadow: "none",
                    }),
                    singleValue: (base) => ({
                        ...base,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin:0
                    }),

                    valueContainer: (base) => ({
                        ...base,
                        height: "48px",
                        padding: "0 12px",
                        display: "flex",
                        alignItems: "center",
                    }),
                    indicatorsContainer: (base) => ({
                        ...base,
                        height: "48px",
                        border:'34px'
                    }),
                }}


            />

            {error && <div className="invalid-feedback d-block">{error}</div>}
        </div>
    );
};

export default PaginatedSelect;
